import { ReduceNode } from './reduceNode';
export class ReduceLogSumNode extends ReduceNode {
    constructor(attributes, inputs, outputs, constants, onnxVersion, mode) {
        super(attributes, inputs, outputs, constants, onnxVersion, 'ReduceLogSum', mode);
    }
    calc(input) {
        return input.reduceLogSum(this.axes, this.keepDims);
    }
}
//# sourceMappingURL=reduceLogSum.js.map